import { getCurrentInstance, ref, onUnmounted } from 'vue'
import { useRequest } from './useRequest'

export function useMsgCode() {
    let phoneReg = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/
    let smsCodeText = ref('获取验证码')
    let msgCodeStatus = ref(false)
    let codeTimer = null
    let sconds = 60
    const { useApi } = useRequest()
    const { proxy } = getCurrentInstance()

    const getMsgCode = async(phone) => {
        if (!phoneReg.test(phone)) {
            return proxy.$toast('请填写正确格式的手机号码')
        }

        if (sconds < 60) {
            return proxy.$toast(`请${sconds}s后再获取`)
        }

        try {
            const { result } = await useApi({ url: '/store_settled/code', method: 'post' }, { phone })

            if (result.success) {
                proxy.$toast.success('验证码已发送')

                let promise = new Promise((resolve) => {
                    let timer = setInterval(() => {
                        if (sconds > 1) {
                            sconds--
                            smsCodeText.value = `${sconds}s`
                        } else {
                            resolve(timer)
                            sconds = 60
                            smsCodeText.value = '获取验证码'
                        }
                    }, 1000)

                    codeTimer = timer
                })
                
                promise.then((timer) => {
                    clearInterval(timer)
                })
            } else {
                proxy.$toast(result.errorMessage)
            }
        } catch (error) {
            console.log('getMsgCode', error)
        }
    }

    const verifyMsgCode = async(phone, smsCode) => {
        if (!phoneReg.test(phone) || smsCode.length !== 6) {
            // console.log('verifyMsgCode', phone, smsCode)
            return
        }
        
        try {
            const { result } = await useApi({ 
                url: '/store_settled/verifySMS', 
                method: 'post' 
            },{ 
                bossPhone: phone, 
                telCode: smsCode
            })

            if (result.success) {
                msgCodeStatus.value = true
            } else {
                msgCodeStatus.value = false
                proxy.$toast(result.errorMessage)
            }
        } catch (error) {
            console.log('verifyMsgCode', error)
        }
    }

    onUnmounted(() => {
        if (codeTimer) {
            clearInterval(codeTimer)
        }
    })

    return {
        smsCodeText,
        getMsgCode,
        verifyMsgCode,
        msgCodeStatus
    }
}